import React from 'react';

export const useWebappNavigate = () => {
  const navigate = (path) => {
    window.location = 'https://' + window.location.hostname + '/app' + path;
  };

  return navigate;
};
